import { INPUT_FIELD_TYPE, INPUT_TYPE } from '@components/DynamicFormField/constant';

export const BBPS_CATEGORY_FORM_CONFIG = [
  {
    key: 'category',
    name: 'category',
    label: 'Category Name',
    placeholder: 'Enter category name',
    fieldType: INPUT_FIELD_TYPE.INPUT,
    inputType: INPUT_TYPE.STRING,
    isEditable: true,
    isRequired: true
  },
  {
    key: 'enabled',
    name: 'enabled',
    label: 'Status',
    placeholder: 'Select status',
    fieldType: INPUT_FIELD_TYPE.SELECT,
    options: [
      { value: true, label: 'Enabled' },
      { value: false, label: 'Disabled' }
    ],
    isEditable: true,
    isRequired: true
  }
];
